import ApprovalQueue from './ApprovalQueue.js';

export default ApprovalQueue;
